import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
import {
  ActiveUser,
  BfxBlotterOrdersContextMenuCancelItem,
  BfxBlotterOrdersContextMenuItem,
  BfxBlotterOrdersContextMenuModifyItem,
  BfxBlotterOrdersContextMenuPromiseService,
  BfxBlotterOrdersContextMenuState,
  ContextMenuItemStateCommandCriteria,
  ContextMenuServiceResponse,
  ContextMenuState,
} from "shared/cubiq-services";
import { BfxBlotterOrdersContextMenuPauseItem } from "shared/cubiq-services/model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuPauseItem";
import { BfxBlotterOrdersContextMenuResumeItem } from "shared/cubiq-services/model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuResumeItem";
import { BfxBlotterOrdersContextMenuFillNowItem } from "shared/cubiq-services/model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuFillNowItem";
import { BasePricingService } from "shared/cubiq-services/lookup/pricing/impl/BasePricingService";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxExecutionMonitorMenuService extends BfxBlotterOrdersContextMenuPromiseService {
  protected menuItems: Array<BfxBlotterOrdersContextMenuItem>;

  constructor(protected pricing: BasePricingService) {
    super();
    this.menuItems = [
      new BfxBlotterOrdersContextMenuFillNowItem(),
      new BfxBlotterOrdersContextMenuModifyItem(), // Modify
      new BfxBlotterOrdersContextMenuCancelItem(),
      new BfxBlotterOrdersContextMenuPauseItem(),
      new BfxBlotterOrdersContextMenuResumeItem(),
    ];
  }

  public getMenuItemsForDataItem(
    item: CubiqTS.OrderDataImpl,
    menuState: BfxBlotterOrdersContextMenuState,
  ): ContextMenuServiceResponse<CubiqTS.OrderDataImpl, BfxBlotterOrdersContextMenuItem> {
    menuState = Object.assign(new BfxBlotterOrdersContextMenuState(), menuState);
    menuState.activeUser = Object.assign(new ActiveUser(), menuState.activeUser);
    menuState.pricingService = this.pricing;
    menuState.reset();

    let menuItems: Array<BfxBlotterOrdersContextMenuItem>;
    menuState.count = 1;

    let itemIndex = 0;

    menuItems = this.menuItems.map<BfxBlotterOrdersContextMenuItem>(
      (menuItem, menuItemIndex, menuItems) => {
        menuItem.reset();
        if (ContextMenuItemStateCommandCriteria.MenuItem === menuItem.checkAvailableCriteria) {
          menuItem.checkAvailable(menuState, menuItem.state, null);
        }
        if (ContextMenuItemStateCommandCriteria.MenuItem === menuItem.checkEnabledCriteria) {
          menuItem.checkEnabled(menuState, menuItem.state, null);
        }
        return menuItem;
      },
    );

    menuItems.forEach((menuItem, menuItemIndex) => {
      menuState.menuItemIndex = menuItemIndex;
      if (ContextMenuItemStateCommandCriteria.Item === menuItem.checkAvailableCriteria) {
        menuItem.checkAvailable(menuState, menuItem.state, item, itemIndex);
      }
      if (ContextMenuItemStateCommandCriteria.Item === menuItem.checkEnabledCriteria) {
        menuItem.checkEnabled(menuState, menuItem.state, item, itemIndex);
      }
    });

    menuItems.forEach((menuItem, menuItemIndex) => {
      menuState.menuItemIndex = menuItemIndex;

      if (ContextMenuItemStateCommandCriteria.PostItem === menuItem.checkAvailableCriteria) {
        menuItem.checkAvailable(menuState, menuItem.state);
      }
      if (ContextMenuItemStateCommandCriteria.PostItem === menuItem.checkEnabledCriteria) {
        menuItem.checkEnabled(menuState, menuItem.state);
      }
    });
    return {
      menuItems: menuItems,
      menuState: menuState,
      actionDecorators: null,
    };
  }

  /**
   * We only support getting the menu for a single selected ID
   * @param selectedIds
   * @param menuState
   */
  public getMenuItems(
    selectedIds: string[],
    menuState: ContextMenuState,
  ): Promise<ContextMenuServiceResponse<CubiqTS.OrderDataImpl, BfxBlotterOrdersContextMenuItem>> {
    throw new Error("Method not implemented.");
  }
}
